import PageLoader from "components/PageLoader";
import React, { createContext, useState } from "react";

interface AppContextValues {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export const AppContext = createContext<AppContextValues>({
  isLoading: false,
  setIsLoading: () => {},
});

const AppProvider: React.FC = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <AppContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
      {isLoading && <PageLoader />}
    </AppContext.Provider>
  );
};

export default AppProvider;
